module.exports = __webpack_public_path__ + "assets/img/36-l.b8fa2fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/36-l.jpg
// module id = 5kNS
// module chunks = 0